module.exports = __webpack_public_path__ + "img/logo.fd1e5572.png";